export const purchaseUrls = {
  salesSystem: 'https://www.compradigitalya.com/cart/42977103347783:1',
  salesWithAi: 'https://www.compradigitalya.com/cart/42977108099143:1',
}

export const testimonials = [
  {
    initials: 'MR',
    name: 'María R.',
    place: 'Córdoba · 32 años · Emprendedora de indumentaria',
    text: 'Lo compré un viernes a la noche y el sábado ya estaba respondiendo consultas con los guiones. Antes me preguntaban precio y entraba en pánico; ahora sé qué decir, cómo seguir y cuándo cerrar. Por primera vez siento que vendo con un método y no por suerte.',
  },
  {
    initials: 'CP',
    name: 'Carolina P.',
    place: 'La Plata · 38 años · Consultora independiente',
    text: 'Una clienta me dijo “es caro” y antes me quedaba muda o terminaba bajando el precio. Con el Tomo 5 entendí cómo responder sin justificarme y sin regalar mi trabajo. Cerré dos presupuestos esta semana con mucha más seguridad.',
  },
  {
    initials: 'JP',
    name: 'Jimena P.',
    place: 'Rosario · 29 años · Cosmética natural',
    text: 'Antes perdía horas mirando la pantalla sin saber qué publicar. Abrí el bono de ideas, elegí una historia, la adapté a mis productos y llegaron consultas esa misma tarde. Me devolvió tiempo y, sobre todo, constancia.',
  },
  {
    initials: 'LT',
    name: 'Lucas T.',
    place: 'Mendoza · 35 años · Fotógrafo de eventos',
    text: 'Ordené mi propuesta con el Tomo 1, subí los precios un 40% y no perdí ningún cliente. Al contrario: cuando expliqué mejor el valor de mi servicio, las consultas fueron mucho más calificadas y dejé de competir solo por precio.',
  },
  {
    initials: 'DS',
    name: 'Daniela S.',
    place: 'Mar del Plata · 41 años · Tienda de decoración',
    text: 'Configuré WhatsApp Business en una tarde siguiendo el paso a paso. Mensajes de bienvenida, respuestas rápidas y catálogo. Ahora mi negocio se ve ordenado y profesional aunque lo manejo yo sola desde casa.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Base Estratégica',
    period: 'Oferta, cliente y precios',
    content: [
      'Cliente ideal, oferta irresistible y diferenciación real',
      'Cómo definir precios sin competir por ser la opción más barata',
      'Los 7 errores que frenan ventas antes del primer mensaje',
      'Una base clara para comunicar por qué elegirse a vos',
    ],
  },
  {
    icon: '📗',
    name: 'Instagram & Facebook',
    period: 'Visibilidad orgánica',
    content: [
      'Perfil optimizado para convertir visitas en consultas',
      'Crecimiento orgánico sin campañas pagas',
      'Marketplace y grupos de Facebook como fuente de clientes',
      'Acciones semanales para atraer nuevos compradores',
    ],
  },
  {
    icon: '📙',
    name: 'Contenido que Vende',
    period: 'Publicar con intención',
    content: [
      'Sistema de contenido diario con intención comercial real',
      'Reels, historias y carruseles que generan consultas',
      'Ideas para educar, demostrar valor y llamar a la acción',
      'Una rutina simple para no volver a quedarte sin publicar',
    ],
  },
  {
    icon: '📕',
    name: 'WhatsApp Business',
    period: 'Conversaciones que cierran',
    content: [
      'Configuración profesional, catálogo y mensajes automáticos',
      'Sistema de cierre en 5 mensajes sin presionar',
      'Seguimiento que acompaña sin sonar desesperado',
      'Respuestas rápidas para ahorrar tiempo todos los días',
    ],
  },
  {
    icon: '📓',
    name: 'Sistema Completo de Ventas',
    period: 'Cerrar, fidelizar y crecer',
    content: [
      '10 técnicas de cierre aplicables a ventas por mensajes',
      '15 objeciones respondidas para vender con confianza',
      'Fidelización y recomendaciones que multiplican clientes',
      'Un sistema repetible para vender sin depender de anuncios',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '💬',
    '500 Mensajes que Venden',
    'Guiones listos para responder, cerrar, hacer seguimiento y pedir recomendaciones. Copiás, pegás y adaptás a tu negocio.',
    '$15.000',
  ],
  [
    '02',
    '📅',
    '365 Ideas de Contenido',
    'Una idea para publicar cada día del año, organizada por objetivo y por mes. Elegís una y la llevás a tus redes en minutos.',
    '$12.000',
  ],
  [
    '03',
    '📱',
    '100 Historias que Generan Ventas',
    'Historias de Instagram y Facebook listas para adaptar, con estructuras, stickers y llamados a la acción incluidos.',
    '$12.000',
  ],
  [
    '04',
    '🗓️',
    'Calendario Inteligente de Publicaciones',
    'Qué publicar, cuándo y con qué objetivo para ordenar tus redes y sostener una presencia que vende durante todo el año.',
    '$10.000',
  ],
  [
    '05',
    '🤖',
    'Guía de Mensajes Automáticos',
    'Configurá WhatsApp Business, Instagram y Facebook para responder más rápido y no perder consultas cuando estás ocupado.',
    '$14.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién estoy empezando?',
    'Sí. El Tomo 1 te ayuda a ordenar tu oferta, tu cliente ideal y tus precios desde cero. Está explicado paso a paso, sin asumir que ya sabés de marketing.',
  ],
  [
    '¿Cómo recibo el material?',
    'Inmediatamente después del pago recibís el acceso por email. En menos de 5 minutos podés tener todos los PDF en tu celular, tablet o computadora.',
  ],
  [
    '¿Funciona para cualquier rubro?',
    'Sí. El sistema se apoya en cómo las personas deciden comprar y en conversaciones de venta, por eso sirve para productos físicos, servicios, productos digitales y negocios locales.',
  ],
  [
    '¿Necesito saber de marketing o publicidad?',
    'No. Todo está explicado en español argentino y con ejemplos prácticos. El foco es vender con tus redes actuales sin necesidad de crear anuncios pagos.',
  ],
  [
    '¿Qué pasa si tengo pocos seguidores?',
    'Podés empezar igual. Vas a trabajar tu perfil, contenido, Facebook Marketplace, grupos y WhatsApp para generar mejores conversaciones con la audiencia que ya tenés y con nuevos contactos.',
  ],
  [
    '¿Los mensajes sirven sin sonar robótico?',
    'Sí. Los guiones son estructuras adaptables, no textos para enviar a ciegas. Podés mantener tu forma de hablar y usar cada mensaje como una guía para responder con claridad.',
  ],
  [
    '¿Incluye ideas para Reels e historias?',
    'Sí. El Tomo 3 y los bonos incluyen ideas, estructuras y llamados a la acción para Reels, carruseles e historias que buscan generar consultas, no solo likes.',
  ],
  [
    '¿Qué aporta el Combo + IA para Emprendedores?',
    'Además de todo el combo base, suma 1.000 prompts de ChatGPT para crear contenido, responder por WhatsApp, presentar ofertas, armar promociones y planificar campañas más rápido.',
  ],
  [
    '¿La garantía de 7 días es real?',
    'Sí. Si dentro de los primeros 7 días revisás el material y sentís que no es para vos, escribinos a compradigitalyaa@gmail.com y te devolvemos el 100% del dinero.',
  ],
  [
    '¿Cuánto tiempo necesito por semana?',
    'Podés empezar con bloques cortos. El objetivo del sistema es que dejes de improvisar: con una estructura clara, crear contenido y responder consultas lleva mucho menos tiempo.',
  ],
] as const

export const moreTestimonials = [
  {
    initials: 'MF',
    name: 'Melina F.',
    place: 'Córdoba · 27 años · Productos naturales',
    text: 'Antes me ponía nerviosa cada vez que alguien preguntaba el precio. Ahora presento el valor, respondo objeciones y sigo la conversación con tranquilidad. No cambié mi producto: cambié cómo lo comunico.',
  },
  {
    initials: 'NG',
    name: 'Natalia G.',
    place: 'Rosario · 36 años · Emprendimiento de moda',
    text: 'El calendario de contenido me salvó. Tengo dos hijos, trabajo y el negocio; no puedo inventar publicaciones todos los días. Ahora sé qué publicar cada semana y las redes dejaron de ser una carga.',
  },
  {
    initials: 'RC',
    name: 'Romina C.',
    place: 'La Plata · 34 años · Coach y terapeuta',
    text: 'Los prompts de IA fueron un antes y después. En veinte minutos tengo ideas para toda la semana, textos para historias y una propuesta para mi próximo taller. Antes eso me llevaba medio día.',
  },
  {
    initials: 'FM',
    name: 'Florencia M.',
    place: 'Mendoza · 43 años · Servicios independientes',
    text: 'Apliqué el método de precios del Tomo 1 y pude aumentar mis honorarios sin sentir culpa. Mis clientes entendieron mejor qué incluye mi servicio y empecé a atraer personas más comprometidas.',
  },
  {
    initials: 'AV',
    name: 'Agustina V.',
    place: 'Buenos Aires · 31 años · Pastelería artesanal',
    text: 'Lo que más me funcionó fue el seguimiento. Tenía un montón de consultas que quedaban en visto y no sabía cómo retomar. Con el protocolo de cuatro contactos recuperé pedidos sin insistir ni incomodar.',
  },
]
